import axiosInstance from '@/utils/api.js'

var state = {
  requestTrafficDetailed: [],
  trafficDetailed: []
}

var getters = {
  REQUEST_TRAFFIC_DETAILED: (state) => {
    return state.requestTrafficDetailed
  },
  TRAFFIC_DETAILED: (state) => {
    return state.trafficDetailed
  }
}

var mutations = {
  SET_REQUEST_TRAFFIC_DETAILED: (state, payload) => {
    state.requestTrafficDetailed = payload
  },
  SET_TRAFFIC_DETAILED: (state, payload) => {
    state.trafficDetailed = payload
  }
}

var actions = {
  GET_REQUEST_TRAFFIC_DETAILED: async (context, payload) => {
    let result = await axiosInstance.get('/reports/request_traffic_detailed?start=' + payload.numDateStart +
    '&end=' + payload.numDateEnd +
    '&user_id=' + payload.userId +
    '&collector_id=' + payload.collector_id +
    '&account_id=0', {timeout: 45000})
    if (result.status === 200) {
      context.commit('SET_REQUEST_TRAFFIC_DETAILED', result.data)
    }
  },
  GET_TRAFFIC_DETAILED: async (context, payload) => {
    let result = await axiosInstance.get('/reports/traffic_detailed?accounting_period_id=0&stop=0&count=0&download=0&limit=' + payload.limit, {timeout: 45000})
    if (result.status === 200) {
      context.commit('SET_TRAFFIC_DETAILED', result.data)
    }
  },
  GET_TRAFFIC_DETAILED_DOWNLOAD: async (context, payload) => {
    let result = await axiosInstance.get('/reports/traffic_detailed?accounting_period_id=0&stop=0&count=0&download=1&limit=' + payload.limit, {timeout: 45000})
    if (result.status === 200) {
      context.commit('SET_TRAFFIC_DETAILED', result.data)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/reports/detailedTraffic.js